<template>
  <div class="page-container">
    <div class="main">
      <page :url="url" :form="form" @reset="reset" ref="pageRef">
        <template slot="tableSearch">
          <el-form-item :label="$t('text.ipAddress')">
            <el-input
                style="width: 300px"
                v-model="form.ipAddress"
                :placeholder="$t('message.input')"
                maxlength="40"
            ></el-input>
          </el-form-item>

        </template>
        <template slot="tableColumn">
          <el-table-column
              prop="createTime"
              width="180px"
              :label="$t('text.startTime')"
              align="center"/>

          <el-table-column
              prop="type"
              width="200px"
              :label="$t('text.type')"
              align="center"
              style="padding-left: 10px"
          />

          <el-table-column
              prop="ipAddress"
              :label="$t('text.ipAddress')"
              align="center"
              width="300px"
              style="padding-left: 10px"
          />

          <el-table-column
              prop="reserved"
              :label="$t('text.appId')"
              align="center"
              width="300px"
              style="padding-left: 10px"
          />

          <el-table-column :label="$t('text.actions')"
                           width="150px"
                           header-align="center"
                           align="center">
            <template slot-scope="scope">
              <el-button v-if="ROLE_TYPE.isManager()"
                         type="danger"
                         size="mini"
                         plain
                         @click="deleteIpCatch(scope.row)">
                {{ $t('text.close') }}
              </el-button>
            </template>
          </el-table-column>

        </template>

      </page>
    </div>
  </div>
</template>
<script>

import Page from "@/components/Page.vue";
import loading from "element-ui/packages/loading";
import moment from "moment";
import {ROLE_TYPE} from "@/utils/Constant";


export default {
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    }
  },
  components: {
    page: Page,
  },
  data() {
    return {
      url: "/ip/disableList/select",
      form: {
        ipAddress: "",
      },
    };
  },
  methods: {
    reset() {
      this.traceId = "";
      this.message = "";
    },
    deleteIpCatch(row) {
      let ipAddress = row.ipAddress;
      let id = row.id;

      this.$confirm(
          this.$t('message.confirmDeletingIp', {ipAddress: ipAddress}),
          this.$t('text.prompt'),
          {
            confirmButtonText: this.$t('text.confirm'),
            cancelButtonText: this.$t('text.cancel'),
            type: "warning"
          })
          .then(() => {
            this.axios
                .delete("/ip/disableList/delete", {params: {
                    id: id,
                    ipAddress: ipAddress,
                  }})
                .then((res) => {
                  if (res.code === 200) {
                    this.$bus.$emit("refresh"); //通知刷新
                    this.$notify({
                      title: this.$t('text.prompt'),
                      message: res.msg,
                      type: "success"
                    });
                  } else {
                    this.$notify.error({
                      title: this.$t('text.prompt'),
                      message: res.msg
                    });
                  }
                });
          })
          .catch((e) => {
            console.log(e);
          });
    },
  },
  created() {
    this.reset();
  },
  mounted() {
    // 注册监听器
    this.$bus.$on("refresh", this.handleRefresh);
  },
  beforeDestroy() {
    // 解除监听器，防止重复注册
    this.$bus.$off("refresh", this.handleRefresh);
  }
};
</script>

<style scoped>
.remark {
  white-space: pre-line;
}

.el-popover pre {
  max-width: 750px;
  max-height: 500px;
  overflow: auto;
  white-space: pre-wrap;
}
</style>